import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';

@Component({
  selector: 'app-addcardtype',
  templateUrl: './addcardtype.component.html',
  styleUrls: ['./addcardtype.component.css']
})
export class AddcardtypeComponent implements OnInit {


//Mode Values
isaddmode:boolean=false;
iseditmode:boolean=false;
isdeletemode:boolean=false;
isviewmode:boolean=false;

//Save Validation
submitted:boolean;
successfully:boolean;

paytypeColl:any=[];

//Edit Get Values
cardtypeColl:any=[];
cardtypeid:number=0

cardtypeform=new FormGroup({         
  cardtypename:new FormControl('',Validators.required),           
  cardtype:new FormControl(''), 
  cardtypeid:new FormControl(0),      
  inactive:new FormControl(false),     
});

isloading:boolean=false;
isprivilage:boolean=false;  
showProgress:boolean=false;
formname:String="CardType";

constructor(private appService: DhukanDataService,private route: ActivatedRoute,
   public router: Router,private toastr: ToastrService,private loginService:LoginDataService) { 
     this.route.queryParams.subscribe(params => {
      if(params.id!==undefined){
        this.cardtypeid = params.id
      }  
     });
     this.fnServiceChanges();
}


fnServiceChanges(){
  this.loginService.serviceloginChange.subscribe((value) => {
        if(this.loginService.fnCheckUser()){
         
          if(this.fnCheckUserPririvilage()){
            this.isloading=true;
            this.fnOnInitForm();
          }
          else{
            this.fnUserFailedForm();
          }
            
        }
        else{
          this.fnUserFailedForm();
        }
  });
}

ngOnInit() {
    try{
      if(this.loginService.fnCheckUser()){ 
        if(this.fnCheckUserPririvilage()){       
          this.isloading=true;
          this.fnOnInitForm();
        }
        else{
          this.fnUserFailedForm();
        }
      }
      else{
        this.loginService.fnGetUserRoleList();
      }
              
    }catch(ex){
      this.fnShowErrorMsg(ex);
    }
}

fnOnInitForm(){
   try{
       this.isaddmode=true;
       this.cardtypeform.reset();
       this.fnInitializecardtypeFormGroup(); 

       if(this.cardtypeid>0){
         this.fngetcardtype();
       }

       
   }catch(ex){
     this.fnShowErrorMsg(ex);
   }
}



fnCheckUserPririvilage(){
  var _check:boolean=false;
  if (this.cardtypeid>0){
    _check= this.loginService.fnCheckUserRoleAction(this.formname,'ALTER')
  }else{
    _check= this.loginService.fnCheckUserRoleAction(this.formname,'CREATE')
  }

  return _check;
}

fnUserFailedForm(){
  this.isprivilage=true;
}


fnInitializecardtypeFormGroup(){
   this.cardtypeform.setValue({
    cardtype:'',
    cardtypename:'',    
    cardtypeid:0,      
    inactive:false,      
   })
}







//Get 
fngetcardtype() {        
     var data = {
       'cardtypeid':this.cardtypeid,            
     }
     this.appService.getCardType(data)
     .subscribe(
       (res)=>{                  
         this.cardtypeColl=res.json().result;
         var editdata = {
           'cardtypeid':this.cardtypeColl[0].cardtypeid,
           'cardtypename':this.cardtypeColl[0].cardtypename, 
           'cardtype':this.cardtypeColl[0].cardtype, 
           'inactive':this.cardtypeColl[0].inactive,          
         }
         this.fnEditMode(editdata);
     },
     (err)=>{          
       this.toastr.error('Error', err);
     })
}

//Save Btn Click
fnSaveBtnClick(){
   try{
     this.submitted=true;
     this.successfully=false;
     //Validate
     if(this.cardtypeform.valid){
         //Check
         var data = {
               'cardtypeid': this.cardtypeid,       
               'cardtype':this.cardtypeform.get('cardtype').value,            
               'cardtypename':this.cardtypeform.get('cardtypename').value,            
               'inactive': 0,  
               'createdby': this.loginService.fnGetModUserId(),    
               'modifiedby':this.loginService.fnGetModUserId(), 
         }
         this.appService.fnCheckCardType(data).subscribe(
           (res)=>{
               var _checkresult=res.json().result[0].checkfield;
             
               if(_checkresult==="done"){
                     if (this.cardtypeform.get('cardtypeid').value>0){
                       //Update Department
                       this.fnSetcardtype(data);
                     }
                     else{
                       //Insert Department
                       this.fnInsertcardtype(data);
                     }
               }
               else{        
                     if(_checkresult==="name"){
                       this.cardtypeform.controls['paytype'].setErrors({'notfound': true});
                     }
               }
         },
         (err)=>{
             this.toastr.error('Error', err);           
         });
      }
   }catch(ex){
     this.fnShowErrorMsg(ex);
   }
}

//Insert
fnInsertcardtype(data){    
 
   this.appService.fnInsertCardType(data).subscribe(
     (res)=>{
     if(res.json().result!=""){
       this.toastr.success('', "The new cardtype has been added successfully.Insert Successfully");

       this.fnInsertActivityLog('INSERT',0,data.cardtype);

       this.fnCloseCardType();
     }},
     (err)=>{
       this.toastr.error('Error', err);
     });

}

//Set
fnSetcardtype(data){    

this.appService.fnSetCardType(data).subscribe(
 (res)=>{
 if(res.json().result!=""){
     this.toastr.success('', "The cardtype has been updated successfully.");

     this.fnInsertActivityLog('EDIT',this.cardtypeid,data.cardtype);

     this.fnCloseCardType();        
 }},
 (err)=>{
   this.toastr.error('Error', err);
 });

}

//Close
fnCloseCardType(){
try{
  this.router.navigate(['/CardType']);
}catch(ex){
   this.fnShowErrorMsg(ex);
}
}

private fnEditMode(deptBO){

 this.cardtypeform.setValue({
  cardtype:deptBO.cardtype,
      cardtypename:deptBO.cardtypename,      
      cardtypeid:deptBO.cardtypeid,
      inactive:deptBO.inactive,   
 });


this.isaddmode=false;
this.iseditmode=true;
this.isdeletemode=false;
this.isviewmode=false;
}


fnInsertActivityLog(action,refno,desc){
  try{
    var data={
      logtype:action,
      logat:this.formname,
      refnum:refno,
      logdescr:desc,
      logby:this.loginService.fnGetModUserId(),
    }
  

    this.appService.fnInsertActivity(data).subscribe(
      (res)=>{
      },
      (err)=>{
     
      });

  }catch{

  }
}



private fnShowProgress(){
  this.showProgress=true;
}
private fnHideProgress(){
  this.showProgress=false;
}

private  fnShowErrorMsg(ex){
this.toastr.warning('Internal Error', ex);       
}





}
